<template>
  <div
    class="fluid-container-custom max-w-screen-xl max-auto pt-12 pb-8 leading-7 text-sm"
  >
    <p class="font-semibold">
      All figures are based on recategorised data extracted from OECD (2025)
      Creditor Reporting System, Government and Civil Society, general
      {{ baseYearRange[0] }}-{{ baseYearRange[1] }}. It has been recategorised
      by the European Democracy Hub team. The focus of this data is core
      democracy support. For more information please reach out to Evelyn Mantoiu
      at evelynmantoiu@epd.eu
    </p>
  </div>
</template>

<script setup>
import {
  
  baseYearRange,
} from "@/assets/baseTypes.js";
</script>

<style lang="scss" scoped></style>
